export default __webpack_public_path__ + "static/media/dNTPs.b339af52.svg";